import script from "./EmptyRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmptyRow.vue?vue&type=script&setup=true&lang=ts"

import "./EmptyRow.vue?vue&type=style&index=0&id=5408f399&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5408f399"]])

export default __exports__